const shareButtons = Array.from(document.querySelectorAll('.j-share'));

const links = {
    vk: 'https://vk.com/share.php?url',
    ok: 'https://connect.ok.ru/offer?url',
    tg: 'https://telegram.me/share/url?url',
    fb: 'https://www.facebook.com/sharer.php?u'
};

if (shareButtons.length) {
    shareButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const social = button.dataset.social;
            const location = window.location.href;
            const URL = `${links[social]}=${location}`;
            const options = 'sharer,status=0,toolbar=0,width=650,height=500';


            if (links[social]) {
                window.open(URL, '_blank', options);
            }
        });
    });
}
